/**
 * API Services.
 */

import axios from 'axios';

export default {

  /**
   * Get Testate principali.
   */
  getSlides() {
    return axios.get('/api/node/testate?sort=ordinamento').then(response => {
      return response.data;
    });
  },

  /**
   * Get Image attributes.
   *
   * @param slide object.
   */
  getSlidesImage(slide) {
    return axios.get(slide.relationships.immagine.links.related).then(response => {
      response.data.url = axios.defaults.baseURL + response.data.data.attributes.url;
      return response.data;
    });
  },

  /**
   * Get Video attributes.
   *
   * @param slide object.
   */
  getSlidesVideo(slide) {
    return axios.get(slide.relationships.video.links.related).then(response => {
      response.data.url = axios.defaults.baseURL + response.data.data.attributes.url;
      return response.data;
    });
  },

  /**
   * Get data Page from drupal urls.
   *
   * @param PageUrl.
   */
  getPage(PageUrl) {
    if (PageUrl !== undefined) {
      return axios.get(PageUrl).then(response => {
        return response.data;
      });
    }
  },

  /**
   * Get Paragraph.
   *
   * @param module.
   */
  getModule(module) {
    let type = module.type;
    type = type.replace(/paragraph--/, '');

    let getRequestUrl = axios.defaults.baseURL + '/api/paragraph/' + type + '/' + module.id;

    return axios.get(getRequestUrl).then(response => {
      return response.data;
    });
  },

  /**
   * Get Relation by api url.
   *
   * @param URL
   */
  getRelationship(Url) {
    return axios.get(Url).then(response => {

      return response.data;
    });
  },
}
